import { render, staticRenderFns } from "./entrustform.vue?vue&type=template&id=1cf3d116&scoped=true&"
import script from "./entrustform.vue?vue&type=script&lang=js&"
export * from "./entrustform.vue?vue&type=script&lang=js&"
import style0 from "./entrustform.vue?vue&type=style&index=0&id=1cf3d116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf3d116",
  null
  
)

export default component.exports